import { COLORS } from '@bumble/app/theme/colors';

export const palette = {
  primary: {
    main: COLORS.PRIMARY,
  },
  secondary: {
    main: COLORS.SECONDARY,
  },
  text: {
    primary: COLORS.TEXT,
  },
  background: {
    default: COLORS.BACKGROUND,
  },
  success: {
    main: COLORS.SUCCESS,
  },
  error: {
    main: COLORS.ERROR,
  },
  warning: {
    main: COLORS.WARNING,
  },
};
